import actions from '@/store/modules/snackbarNotification/actions';
import mutations from '@/store/modules/snackbarNotification/mutations';

const state = {
  stack: [],
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
